// extracted by mini-css-extract-plugin
export default {"indicator-row":"StepIndicator_indicator-row__5qE7R","step-indicator-container":"StepIndicator_step-indicator-container__bOH2Q"};